module.exports = __webpack_public_path__ + "static/media/download.62e28129.svg";